import { IberisActivities } from "../models/iberis/activities";
export class Constants {
  /* ENDPOINTS */
  public static FILE_STORAGE_ENDPOINT = "https://cdn.relead.tn/";
  public static USER_ENDPOINT = "/users";
  public static ADMIN_ENDPOINT = "/admin";
  public static CONSUMER_ENDPOINT = "/consumer";
  public static FILE_ENDPOINT = "/files";
  public static ADVERTISER_ENDPOINT = "/advertisers";
  public static STATICS_ENDPOINT = "/statistics";
  public static ADVERTISING_CAMPAIGN_ENDPOINT = "/advertising-campaigns";
  public static CALENDAR_TICKET_ENDPOINT = "/calendar/ticket";
  public static ROUTER_ENDPOINT = "/routers";
  public static BUG_REPORT_ENDPOINT = "/bug-reports";
  public static BILLING_ENDPOINT = "/billings";
  public static LOCATION_PARTNER_ENDPOINT = "/location-partners";
  public static FRANCHISE_ENDPOINT = "/franchises";
  public static CATEGORY_ENDPOINT = "/categories";
  public static FIXED_CHARGES = "/fixed-charges";
  public static SUB_CATEGORY_ENDPOINT = "/sub-categories";
  public static TAG_ENDPOINT = "/tags";
  public static ZONE_ENDPOINT = "/zones";
  public static REGION_ENDPOINT = "/regions";
  public static ROLE_ENDPOINT = "/roles";
  public static SUB_ROLE_ENDPOINT = "/sub-roles";
  public static GROUP_AUTHORITY_ENDPOINT = "/group-authorities";
  public static OBJECTIVE_ENDPOINT = "/objectives";
  public static MAILS_END_POINT = "/mails";
  public static COMMANDE_END_POINT = "/orders";
  public static HISTORY_END_POINT = "/histories";
  public static IBERIS_END_POINT = "/api/public/company/";
  public static PAYMEE_END_POINT = "/api/v2/payments";
  public static KONNECT_END_POINT = "/api/v2";
  public static PROMOTION_CODE_END_POINT = "/promotion-codes";
  public static RECAPTCHA = "/recaptcha";
  public static AUTHORITIES = "/authorities";
  public static VOUCHERS = "/vouchers";
  public static FEATURES = "/features";
  public static CLICKUP = "/clickUp"

  public static DATE_IBERIS = new Date();
  public static DUE_DATE_IBERIS = new Date().setDate(
    this.DATE_IBERIS.getDate() + 30
  );

  public static VIDEO_GUIDE_LINK =
    "https://drive.google.com/file/d/1ACdyG_PLJFfmHZwyrP7O1Wzf-95oQCl4/view?usp=drive_link";
  public static IBERIS_ACTIVITIES_EN: IberisActivities[] = [
    {
      title: "Agency or commercial company",
      hashed_id: "Dl",
    },
    {
      title: "Agriculture",
      hashed_id: "Er",
    },
    {
      title: "Art and design",
      hashed_id: "GZ",
    },
    {
      title: "Automobile industry",
      hashed_id: "JD",
    },
    {
      title: "Construction",
      hashed_id: "Kl",
    },
    {
      title: "Consumer goods",
      hashed_id: "Lq",
    },
    {
      title: "Education",
      hashed_id: "Mo",
    },
    {
      title: "Engineering",
      hashed_id: "Nl",
    },
    {
      title: "Entertainment",
      hashed_id: "OR",
    },
    {
      title: "Financial services",
      hashed_id: "mwj",
    },
    {
      title: "Catering activities",
      hashed_id: "nOg",
    },
    {
      title: "Games",
      hashed_id: "oyJ",
    },
    {
      title: "Public function",
      hashed_id: "pwQ",
    },
    {
      title: "Health services",
      hashed_id: "qWk",
    },
    {
      title: "Interior decoration",
      hashed_id: "rVv",
    },
    {
      title: "Internal",
      hashed_id: "vJN",
    },
    {
      title: "Legal",
      hashed_id: "wNy",
    },
    {
      title: "Industry",
      hashed_id: "xJJ",
    },
    {
      title: "Marketing",
      hashed_id: "yJA",
    },
    {
      title: "Mining and logistics",
      hashed_id: "JnX",
    },
    {
      title: "Non-profit",
      hashed_id: "Kov",
    },
    {
      title: "Publishing and web media",
      hashed_id: "LpB",
    },
    {
      title: "Retail (e-commerce and offline)",
      hashed_id: "MAB",
    },
    {
      title: "Real estate",
      hashed_id: "NAj",
    },
    {
      title: "Services",
      hashed_id: "OYp",
    },
    {
      title: "Technology",
      hashed_id: "PDx",
    },
    {
      title: "Telecommunications",
      hashed_id: "QAv",
    },
    {
      title: "Tourism / hospitality",
      hashed_id: "RAp",
    },
    {
      title: "Web design",
      hashed_id: "VMP",
    },
    {
      title: "Web development",
      hashed_id: "mwR",
    },
    {
      title: "Leather goods",
      hashed_id: "nOL",
    },
  ];

  public static IBERIS_ACTIVITIES_FR: IberisActivities[] = [
    {
      title: "Agence ou société commerciale",
      hashed_id: "Dl",
    },
    {
      title: "Agriculture",
      hashed_id: "Er",
    },
    {
      title: "Art et design",
      hashed_id: "GZ",
    },
    {
      title: "Industrie automobile",
      hashed_id: "JD",
    },
    {
      title: "Construction",
      hashed_id: "Kl",
    },
    {
      title: "Biens de consommation",
      hashed_id: "Lq",
    },
    {
      title: "Éducation",
      hashed_id: "Mo",
    },
    {
      title: "Ingénierie",
      hashed_id: "Nl",
    },
    {
      title: "Divertissement",
      hashed_id: "OR",
    },
    {
      title: "Services financiers",
      hashed_id: "mwj",
    },
    {
      title: "Activités de restauration",
      hashed_id: "nOg",
    },
    {
      title: "Jeux",
      hashed_id: "oyJ",
    },
    {
      title: "Fonction publique",
      hashed_id: "pwQ",
    },
    {
      title: "Services de santé",
      hashed_id: "qWk",
    },
    {
      title: "Décoration d'intérieur",
      hashed_id: "rVv",
    },
    {
      title: "Interne",
      hashed_id: "vJN",
    },
    {
      title: "Légal",
      hashed_id: "wNy",
    },
    {
      title: "Industrie",
      hashed_id: "xJJ",
    },
    {
      title: "Commercialisation",
      hashed_id: "yJA",
    },
    {
      title: "Exploitation minière et logistique",
      hashed_id: "JnX",
    },
    {
      title: "Non lucratif",
      hashed_id: "Kov",
    },
    {
      title: "Publication et médias Web",
      hashed_id: "LpB",
    },
    {
      title: "Vente au détail (e-commerce et hors ligne)",
      hashed_id: "MAB",
    },
    {
      title: "Immobilier",
      hashed_id: "NAj",
    },
    {
      title: "Service",
      hashed_id: "OYp",
    },
    {
      title: "Technologie",
      hashed_id: "PDx",
    },
    {
      title: "Télécommunications",
      hashed_id: "QAv",
    },
    {
      title: "Tourisme / hôtellerie",
      hashed_id: "RAp",
    },
    {
      title: "Création de sites web",
      hashed_id: "VMP",
    },
    {
      title: "Développement web",
      hashed_id: "mwR",
    },
    {
      title: "Maroquinerie",
      hashed_id: "nOL",
    },
  ];

  public static availibilityCondition =
    "Certaines des emplacements que vous avez sélectionnées peuvent ne pas être incluses dans le devis car elles ne sont pas disponibles. D'autres emplacements peuvent être partiellement disponibles, avec une disponibilité limitée sur un nombre restreint de jours, et non pour toute la durée de la campagne.";

  public static privateKeyPlaceholder = `-----BEGIN PRIVATE KEY-----
  6NAbm5drfgq82XuZjDdgfZ2Nimx1JJyx4NJ4CyypTNRm7k6dNR9YRw5FCDnexQ8XZDYEptxj40U2Jpz6RrmTiUrjM5kTZecKEPPCrrnTRXkESkD57ZmgntkBbhQAJbchcbkNACU1EdK7pm3SWT5aEw7cLXqm3TmimHACcTuKdugLAYYQVTEdQWnEEvhbie0WDRia3NzvefwJa6cgWuiNhPBiNA7ipDMHeKtKwbvMJb8LWbfN5G63XZ6DWL3UNL2H1X7kCHjWvM2PV6wcQe6NDR6u5idVBfjARRAxYC6qwJqWxBBN87SE7H2DkJugBSzgcKQhxvgRZZFSzSjaukZZGNWXYf23dYV33UQhHGr8UgGD11fDq626KJ7vpf33HVGXbVkZS4aRzQ4mkkprHSZFNW9NF7cCUg6MmtDwrSPmzyqVqixB6gNZiBDMFSrApxC6USHUiVR2xNNJqjK9a5yc0PF06Lb4NepUZ2Yrz5j5DySUJZrHiPuqKw993Dt2GiS6cW3AxvAnFHdAg2SD5RfMMctRBwYjYxKQLSBvhdA0pfwA9u3nDmrbk9nyYCTDiVft29SLNUHeL4WJwBCHqittkLSwWXGKk9gWTTU849jSKeMDaQrUdR4hbWmPZkSfSGxpr6HwKehKDm2DLXXDZ1xNUQx4pddc2J8DSCHBA9uCzQnDmrZPf8Hjk16DQXE9DEPXRSPmFp4a7UGwQi5P3TrL36iHLYC0M8P4De0zimyRjG15SRnGKnwdehYDqR0NEXjAZGjw8gJkcphiY4iJqR9tXDHMyGQgEdqbEXMbctVmQjJEi4C2w0mCR7wxQE9zdN2QggS91MNnvxHkgH1vCZrPNpLNDdQfBZ6z8vzxQE4mMw9nYRA62xR891WPWdt456AH0J4Z97a10fyqcf2qXm3wFpGtZhKSzttLrBcrUuHw2i0QjrM5GUVZy2j6iZunW1Xm0WzQAhE5AWS3CwAmVUXRJg9RCTrriY5gEaGQWrAic9Wa602NgwH8rwdzmHwZfwq9AJ5AMvNNbjhpfDUi4ABr15PHmE45rFbeev4qKvSJpu4vpgap7tyTv1EK7bdT8dRY79nBtjvA36fWRqaf5BDYWghWUj404v5Mv8W1WRwMvhNFYb5fEMbjkkWCn1BJrP6z8dhBVW14z0BWD2Z5htrUMbDw9BSukypWSzMZQhCbMUpYFVRv5GbNYWZyaPhWhezPv0bpTLy82QNkXub3itYc2LXXYLnYdE3fvQ5hg5nfmS9cvNPEktBhW4uxHdMKB20zrCJwqmFczmbVcjJtSXgN6U4bRXpfvjnGH3FqLC2Fh3iz3gEaKVMWhVCTdwWawWeP6k1i47Y9CkL4PKduNimP5dYEcQPAjhEUqeG7pe8H3M18ayryv0qMBRY1AL95THnrMmLgSLz3BdT63r9UNn7adK70Wwte80c4dqwP1X3Qde9eZgpVCABAa33RYyjxywTuJmJ6bAK0LvxEFAGjLHqeCA3LgMP4D7ckmRCHbKM6GZhMSLjFJdHziQH7pVYUnc7czZn0TacLSuSbwpu9f7tvuVBGy4zgpfhXu7rUwLJmmebMQKzeMaqRGij4P0SCKyWV5p1nc5Cw6pAap6jwmNh6
  -----END PRIVATE KEY-----`;

  public static oneDay = 86400000

  public static defaultTableSize = 10

  public static sevenDaysAgo = new Date(new Date().getTime() - 7 * Constants.oneDay);

  public static twoMonthsAgo = new Date(
    new Date().setMonth(new Date().getMonth() - 2)
  );

  public static twoWeeksAgo = new Date(
    new Date().getTime() - 14 * 24 * 60 * 60 * 1000
  );
}
